import { lazy } from "react"

// ── Combined workspaces (Phase 1: Combi-Windows) ─────────────────────────────
// Single source for the three consolidated screens. Each groups two existing
// pages under a segmented toggle. The sub-page components are lazy so nothing
// loads until a tab is shown. Consumed by:
//   • workspace/WorkspacePage.jsx  — full-page routes (/assistants, /knowledge, /dev)
//   • spotlight/SpotlightSearch.jsx — floating-window defs (WINDOW_DEFS)
//   • shared/NavRail.jsx            — one nav icon per workspace

const JarvisPage       = lazy(() => import("../chat/JarvisPage"))
const FridayPage       = lazy(() => import("../chat/FridayPage"))
const HermesPage       = lazy(() => import("../hermes/HermesPage"))
const DeepResearchPage = lazy(() => import("../deep-research/DeepResearchPage"))
const VaultPage        = lazy(() => import("../vault/VaultPage"))
const DatabasePage     = lazy(() => import("../database/DatabasePage"))
const IDEPage          = lazy(() => import("../ide/IDEPage"))

export const WORKSPACES = {
  assistants: {
    id: "assistants", label: "ASSISTANTS", route: "/assistants",
    color: "var(--agent-jarvis)", desc: "JARVIS, FRIDAY & HERMES",
    keywords: ["assistants", "assistant", "jarvis", "friday", "hermes", "orchestrator", "chat", "ki", "ai", "a"],
    tabs: [
      { id: "jarvis", label: "JARVIS", color: "var(--agent-jarvis)", component: JarvisPage },
      { id: "friday", label: "FRIDAY", color: "var(--agent-friday)", component: FridayPage },
      { id: "hermes", label: "HERMES", color: "var(--feature-hermes)", component: HermesPage },
    ],
  },
  knowledge: {
    id: "knowledge", label: "KNOWLEDGE", route: "/knowledge",
    color: "var(--feature-vault)", desc: "Deep Research & Vault",
    keywords: ["knowledge", "wissen", "research", "deep", "forschung", "vault", "graph", "wiki", "k"],
    tabs: [
      { id: "research", label: "DEEP RESEARCH", color: "var(--feature-research)", component: DeepResearchPage },
      { id: "vault", label: "VAULT", color: "var(--feature-vault)", component: VaultPage },
    ],
  },
  dev: {
    id: "dev", label: "DEV", route: "/dev",
    color: "var(--feature-database)", desc: "Datenbank & IDE",
    keywords: ["dev", "database", "datenbank", "db", "sql", "ide", "code", "editor", "d"],
    tabs: [
      { id: "database", label: "DATENBANK", color: "var(--feature-database)", component: DatabasePage },
      { id: "ide", label: "IDE", color: "var(--app-info)", component: IDEPage },
    ],
  },
}

export const WORKSPACE_LIST = Object.values(WORKSPACES)

// Old single-page route → { workspace, tab } so NavRail can highlight the merged
// icon and deep links can pre-select a tab.
export const ROUTE_TO_WORKSPACE = {
  "/jarvis":   { ws: "assistants", tab: "jarvis" },
  "/friday":   { ws: "assistants", tab: "friday" },
  "/hermes":   { ws: "assistants", tab: "hermes" },
  "/research": { ws: "knowledge",  tab: "research" },
  "/vault":    { ws: "knowledge",  tab: "vault" },
  "/database": { ws: "dev",        tab: "database" },
  "/ide":      { ws: "dev",        tab: "ide" },
}
